import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  
  const toggleLanguage = () => {
    const newLang = i18n.language === 'ar' ? 'en' : 'ar';
    i18n.changeLanguage(newLang);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-2 text-muted-foreground hover:text-white hover:bg-zinc-800"
      data-testid="language-toggle"
    >
      <Globe className="w-4 h-4" />
      <span className="font-medium">{i18n.language === 'ar' ? 'EN' : 'ع'}</span>
    </Button>
  );
}
